interface UserProfileHeaderTypes {
    data?: any;
    uploadedByName?: string;
}

const UserProfileHeader = ({
    data,
    uploadedByName

}: UserProfileHeaderTypes) => {

     
    const uploadedByProfileImage = 
     data?.media?.uploadedBy?.profileImage 
    ? data?.media?.uploadedBy?.profileImage 
    : null;


    return (

        <div className="mt-3">
            <div
                className="d-flex justify-content-center  align-items-center"
            >
             
                <img
                    style={{ objectFit: "contain" }}
                    height={30}
                    width={30}
                    className="me-2 rounded-circle border border-primary"
                    src={uploadedByProfileImage ? uploadedByProfileImage : process.env.PUBLIC_URL + "/media/avatars/blank.png"}
                    loading="lazy"
                />
                <p
                    style={{ fontSize: "12px" }}
                    className="mb-0"
                >
                    {uploadedByName}
                </p>

            </div>
        </div>
    );
};

export default UserProfileHeader;